import { IconProps } from "models"

const RightWave: React.FC<IconProps> = ({
	className = "",
	style = null,
	width = "494",
	height = "209",
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 494.1 208.8"
			className={className}
			style={style}
			width={width}
			height={height}
			aria-hidden="true"
		>
			<path
				d="M1.83.25C6 8.89 133.78 109.43 279.17 140.12c57.58 12.16 181.5 44 214.91 68.69-26.6-.23-492.25 0-492.25 0S-2.29-8.39 1.83.25Z"
				fill="var(--primaryColor)"
				opacity=".2"
			/>
		</svg>
	)
}

export default RightWave
